import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Card, Grid, Tab, Tabs } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import InfoHubMap from "./components/map";
import MetroStatusCard from "./components/MetroStatusCard";
import TableKtelInfoHub from "./components/table/TableKtelInfoHub";
import TableAirportInfoHub from "./components/table/TableAirportInfoHub";
import InfoHubChart from "./components/charts";

function TabPanel({ children, value, index, noPadding = false }) {
  if (value !== index) return null;

  return <Box sx={{ p: noPadding ? 0 : 2, mt: 2 }}>{children}</Box>;
}

function InfoHub() {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  return (
    <DashboardLayout>
      <Card>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          {/* <Tab label="Multimodal KPIs" />
          <Tab label="Upcoming Departures & Arrivals" />
            <Tab label="Transport Stations Map" /> */}
          <Tab label={t("trafficMonitoring.infohub.tabs.kpis")} />
          <Tab label={t("trafficMonitoring.infohub.tabs.departuresArrivals")} />
            <Tab label={t("trafficMonitoring.infohub.tabs.map")} />
        </Tabs>

        <TabPanel value={tabIndex} index={0}>
          <Grid container direction="column" spacing={2}>

            <Grid item>
              <InfoHubChart />
            </Grid>
          </Grid>
        </TabPanel>


        <TabPanel value={tabIndex} index={1}>
          <MDBox sx={{ mt: 2 }}>
            <MDTypography
              variant="h4"
              fontWeight="bold"
              sx={{ marginBottom: 2 }}
            >
              {t("trafficMonitoring.infohub.intercityBusTitle")}
            </MDTypography>
            <TableKtelInfoHub />
          </MDBox>
          <MDBox sx={{ mt: 2 }}>
            <MDTypography
              variant="h4"
              fontWeight="bold"
              sx={{ marginBottom: 2 }}
            >
              {t("trafficMonitoring.infohub.airportTitle")}
            </MDTypography>
            <TableAirportInfoHub />
          </MDBox>
        </TabPanel>

          <TabPanel value={tabIndex} index={2} noPadding>
          <InfoHubMap />
        </TabPanel>
      </Card>
    </DashboardLayout>
  );
}

export default InfoHub;
